(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/views/betslippayoptions.js') >= 0) return;  svs.modules.push('/modules/tipset/views/betslippayoptions.js'); (function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.tipset=_svs.tipset||{};
_svs.tipset.templates=_svs.tipset.templates||{};
svs.tipset.templates.betslippayoptions = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.overviewOpen : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.program(7, data, 0),"data":data})) != null ? stack1 : "");
},"2":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.isSingleRow : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.program(5, data, 0),"data":data})) != null ? stack1 : "");
},"3":function(container,depth0,helpers,partials,data) {
    return "    Visa översikt av spelet\n";
},"5":function(container,depth0,helpers,partials,data) {
    return "    Dölj översikt av spelet  \n";
},"7":function(container,depth0,helpers,partials,data) {
    return "  Visa översikt av spelet\n";
},"9":function(container,depth0,helpers,partials,data) {
    return "<div id=\"sportkryssRegion\"></div>\n";
},"11":function(container,depth0,helpers,partials,data) {
    return "<div id=\"weeekPickerRegion\"></div>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return "<div class=\"padding\">\n"
    + ((stack1 = (helpers.ui || (depth0 && depth0.ui) || helpers.helperMissing).call(alias1,"button",{"name":"ui","hash":{"transparent":true,"icon-position":"right","icon":"viewsummary","block":true,"size":300,"class":"betslip-overview","id":"betslip-overview"},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "</div>\n\n"
    + ((stack1 = helpers.unless.call(alias1,(depth0 != null ? depth0.isReduceMode : depth0),{"name":"unless","hash":{},"fn":container.program(9, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\n<div id=\"betAmountPickerRegion\"></div>\n<div id=\"bombenRegion\"></div>\n\n"
    + ((stack1 = helpers.unless.call(alias1,(depth0 != null ? depth0.isReduceMode : depth0),{"name":"unless","hash":{},"fn":container.program(11, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\n<div class=\"retailCommissionPicker\">\n</div>\n\n<div id=\"betslipErrorMessage\">\n</div>\n";
},"useData":true});
Handlebars.partials['svs-tipset-betslippayoptions'] = svs.tipset.templates.betslippayoptions;
})(svs, Handlebars);

 })(window);